import { render, staticRenderFns } from "./ChatContactFormSubmit.vue?vue&type=template&id=004016c6&"
import script from "./ChatContactFormSubmit.vue?vue&type=script&lang=js&"
export * from "./ChatContactFormSubmit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports